import { ProtocolArray, frameRawWithArea } from "@gotti/core";
import { BaseClientConnector } from './BaseClientConnector.js';
import { Client } from "../Client.js";

export type ClientConnectorWebSocketoptions = {
  wsEndpoint: string,
}

export class ClientConnectorWebSocket extends BaseClientConnector {
    private wsClient : WebSocket;
    constructor(client: Client) {
        super(client);
    }

    public async connect(opts) {

        let protocol = 'ws:';
        if(typeof window !== "undefined" && window?.location?.protocol === 'https:') {
            protocol = 'wss:'
        }

        this.onDisconnect();
        //console.log('url was', `${protocol}//${opts.host}:${opts.port}?privateId=${opts.privateId}&publicId=${opts.publicId}`)
        this.wsClient = new WebSocket(`${protocol}//${opts.host}:${opts.port}?privateId=${opts.privateId}&publicId=${opts.publicId}`)
        this.wsClient.binaryType = 'arraybuffer';
        return new Promise((resolve, reject) => {
            this.wsClient.addEventListener('message', (event) => {
                const data = event.data;
                if (typeof data === 'string') {
                    this.onServerMessage(JSON.parse(data));
                } else if (data instanceof ArrayBuffer) {
                    this.client.handleRawAreaMessage(data);
                } else if (data instanceof Blob) {
                    data.arrayBuffer().then((buffer) => {
                        this.client.handleRawAreaMessage(buffer);
                    });
                }
            });
            // Socket death → drive the auto-reconnect loop. onConnectionLost is
            // cleared by disconnect() FIRST on a deliberate teardown, so these
            // only fire on an UNEXPECTED close/error. (error usually precedes
            // close; handleConnectionLost's `reconnecting` guard dedupes.)
            this.wsClient.addEventListener('close', () => this.onConnectionLost?.());
            this.wsClient.addEventListener('error', () => this.onConnectionLost?.());
            this.wsClient.addEventListener('open', (e) => {
                return resolve(true)
            })
        })
    }
    public onDisconnect() {
        if(this.wsClient?.readyState === WebSocket.CONNECTING || this.wsClient?.readyState === WebSocket.OPEN) {
            this.wsClient.close();
            delete this.wsClient;
        }
    }

    public send(data: ProtocolArray) {
        this.wsClient.send(JSON.stringify(data));
    }

	// Binary fast path — no protocol envelope, so the target area rides in the
	// frame header (always written, even when absent — see frameRawWithArea).
	public override sendRaw(data: ArrayBuffer, _ensureReliable = true, _ensureOrdered = true, areaId?: string) {
		this.wsClient.send(frameRawWithArea(data, areaId));
	}
}